module.exports = require("/tmp/store-build/master/src/redux/store")